import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=368405b8&"
import script from "./AccessControl.vue?vue&type=script&lang=js&"
export * from "./AccessControl.vue?vue&type=script&lang=js&"
import style0 from "./AccessControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports